import Splide from "@splidejs/splide";
import "@splidejs/splide/css/core";

// =====================================================
// 商品詳細ページ: 画像スライダー
// =====================================================
const singleProductsSlider = document.querySelector( ".js-products-single-splide" );

if ( singleProductsSlider )
{
    const fraction = singleProductsSlider.querySelector( ".p-products-single-splide__fraction" );

    const splide = new Splide( singleProductsSlider, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: true,

        classes: {
            arrows: "splide__arrows p-products-single-splide__arrows",
            arrow: "splide__arrow p-products-single-splide__arrow",
            prev: "splide__arrow--prev p-products-single-splide__arrow--prev",
            next: "splide__arrow--next p-products-single-splide__arrow--next",
        },
    } ).mount();

    // 次のスライドが表示されるタイミングで発生
    splide.on( "active", function ()
    {
        slideIndex();
    } );

    function slideIndex ()
    {
        if ( !fraction )
        {
            return;
        }

        // 現在のスライドが何枚目かを取得
        // スライドの総数を取得
        fraction.textContent = `${ splide.index + 1 }/${ splide.length }`;
    }

    slideIndex();
}

// =====================================================
// 商品一覧ページ: 絞り込みパネルの開閉・選択中チップの表示
// =====================================================
const productsFilterToggle = document.querySelector( ".js-products-filter-toggle" );
const productsMenu = document.querySelector( ".p-products-menu" );
const productsMenuCloseBtn = document.querySelector( ".p-products-menu__btn" );

if ( productsFilterToggle && productsMenu )
{
    productsFilterToggle.addEventListener( "click", () =>
    {
        productsMenu.classList.add( "is-open" );
    } );
}

if ( productsMenuCloseBtn && productsMenu )
{
    productsMenuCloseBtn.addEventListener( "click", () =>
    {
        productsMenu.classList.remove( "is-open" );
    } );
}

const productsFilterItems = document.querySelectorAll( ".js-products-filter-item" );
const productsSelectedList = document.querySelector( ".js-products-selected-list" );

// チェックされている絞り込み条件を「選んだ条件」欄にチップとして並べ直す
// (チップをクリックするとチェックを外して再描画する)
function renderSelectedChips ()
{
    if ( !productsSelectedList )
    {
        return;
    }

    productsSelectedList.innerHTML = "";

    document.querySelectorAll( ".js-products-filter-item:checked" ).forEach( ( item ) =>
    {
        const chip = document.createElement( "li" );
        chip.className = "p-products-selected__item u-background-white-01 u-border-blue-01-1 u-radius--8 u-padding-block--4 u-padding-inline--16";
        chip.textContent = item.dataset.termName;

        chip.addEventListener( "click", () =>
        {
            item.checked = false;
            renderSelectedChips();
        } );

        productsSelectedList.appendChild( chip );
    } );
}

productsFilterItems.forEach( ( item ) =>
{
    item.addEventListener( "change", renderSelectedChips );
} );

renderSelectedChips();

// =====================================================
// 商品詳細ページ: お気に入りボタン(Ajaxでリロードなしに切り替え)
// =====================================================
const favoriteButtons = document.querySelectorAll( ".js-favorite-toggle" );
const favoriteNotice = document.querySelector( ".js-favorite-notice" );
const favoriteQuoteTotal = document.querySelector( ".js-favorite-quote-total" );

function showFavoriteNotice ( message )
{
    if ( !favoriteNotice )
    {
        return;
    }

    favoriteNotice.textContent = message;
    favoriteNotice.hidden = false;
}

function hideFavoriteNotice ()
{
    if ( favoriteNotice )
    {
        favoriteNotice.hidden = true;
    }
}

favoriteButtons.forEach( ( button ) =>
{
    button.addEventListener( "click", () =>
    {
        const ajaxConfig = window.podFavorite;
        const productId = button.dataset.productId;

        if ( button.disabled || !productId || !ajaxConfig )
        {
            return;
        }

        // 連打防止のため、通信中はボタンを無効化する
        button.disabled = true;
        hideFavoriteNotice();

        // Ajaxでお気に入りのON/OFFを切り替える(toggle_favorite_product、ページ側で処理)
        const formData = new FormData();
        formData.append( "action", "toggle_favorite_product" );
        formData.append( "product_id", productId );
        formData.append( "nonce", ajaxConfig.nonce );

        fetch( ajaxConfig.ajaxUrl, {
            method: "POST",
            credentials: "same-origin",
            body: formData,
        } )
            .then( ( response ) => response.json() )
            .then( ( result ) =>
            {
                if ( !result.success )
                {
                    showFavoriteNotice( result.data?.message ?? "通信に失敗しました。時間をおいて再度お試しください。" );
                    return;
                }

                const isActive = result.data.is_favorite;

                button.classList.toggle( "is-active", isActive );
                button.setAttribute( "aria-pressed", isActive ? "true" : "false" );

                const icon = button.querySelector( ".js-favorite-icon" );
                if ( icon )
                {
                    icon.src = isActive ? "/img/common/favorite-cancel.svg" : "/img/common/favorite-add.svg";
                    icon.alt = isActive ? "お気に入りから削除" : "お気に入りに追加";
                }

                if ( button.classList.contains( "u-btn-favorite--long" ) )
                {
                    button.textContent = isActive ? "この商品をお気に入り解除する" : "この商品をお気に入り追加する";
                }

                // お気に入り一覧ページでは、解除した商品のカードをその場で取り除く
                const favoriteCard = button.closest( ".js-favorite-card" );
                if ( favoriteCard && !isActive )
                {
                    favoriteCard.remove();

                    if ( favoriteQuoteTotal )
                    {
                        favoriteQuoteTotal.textContent = document.querySelectorAll( ".js-favorite-card" ).length;
                    }

                    document.dispatchEvent( new CustomEvent( "favorite:removed" ) );
                }
            } )
            .catch( () =>
            {
                showFavoriteNotice( "通信に失敗しました。時間をおいて再度お試しください。" );
            } )
            .finally( () =>
            {
                button.disabled = false;
            } );
    } );
} );

